module.exports = __webpack_public_path__ + "src/images/products/prep/44_Cotton Cashmere Silk Sweater.png";